import { usePathname, useGlobalSearchParams } from 'expo-router';
import { isMessagesChannelScreen } from '@/shared/utils';

export function useIsMessagesChannel() {
  const pathname = usePathname();
  const { channelUrl } = useGlobalSearchParams<{ channelUrl?: string }>();
  return isMessagesChannelScreen(pathname, channelUrl);
}
